import { useCallback, useMemo } from "react";
import { Menu, Dropdown } from "antd";
import { useDispatch } from "react-redux";
import {Link, useHistory} from "react-router-dom";
import { ROUTES } from "utils/constants";

import { actionMenu } from "svgs";
import {BatteryState} from "types/store";
import {getVehicle, setModalName, setSelectedBattery} from "../../../store/actions";


export default function DropdownAction({
  battery,
}: {
    battery: BatteryState["selectedBattery"];
}) {
  const dispatch = useDispatch();
    const history = useHistory();
    const onDelete = useCallback((e) => {
      e.domEvent.stopPropagation(); 
        dispatch(setSelectedBattery(battery));
        dispatch(setModalName("delete_battery"));
    }, [dispatch]);

    const onBatteryDetail = useCallback( (e) => {
      e.domEvent.stopPropagation(); 
        dispatch(setSelectedBattery(battery));
        history.push(`${ROUTES.battery_detail}/${battery?.id}`);
    }, [dispatch]);


  const menu = useMemo(
    () => (
      <Menu>
          <Menu.Item key="1">
          </Menu.Item>

          <Menu.Item key="1" onClick={onBatteryDetail}>
              Battery Details
          </Menu.Item>
          <Menu.Item key="3" className="delete-action" onClick={onDelete}>
              Archive
          </Menu.Item>

      </Menu>
    ),
    [onDelete, onBatteryDetail]
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <a className="ant-dropdown-link" onClick={(e) => e.stopPropagation()}>{actionMenu}</a>
    </Dropdown>
  );
}
